import { Box, Stack, Heading, Text, Alert } from 'braid-design-system';
import { useTranslation } from 'react-i18next';

/**
 * Shown when an authenticated user has no it_user_menu grant for the page they
 * asked for (or no menus at all). Distinct from NotFoundPage: the route exists,
 * the account just has not been given access.
 */
const NoAccessPage = () => {
    const { t } = useTranslation();

    return (
        <Box padding="large" display="flex" alignItems="center" justifyContent="center">
            <Stack space="large" align="center">
                <Heading level="1" align="center">
                    {t('page.no_access.heading', { defaultValue: 'No access' })}
                </Heading>
                <Alert tone="caution">
                    <Text>
                        {t('page.no_access.message', {
                            defaultValue: 'Your account does not have access to this page. Please contact your administrator to have the required menus assigned.',
                        })}
                    </Text>
                </Alert>
            </Stack>
        </Box>
    );
};

export default NoAccessPage;
